import type { ApprovalWorkflow } from '../types';

// Mock data for demo mode
export const MOCK_APPROVALS: ApprovalWorkflow[] = [
  {
    id: '1',
    name: 'Standard Timesheet Approval',
    status: 'Active',
    stages: 2,
    assignedEmployees: 45,
    lastModified: new Date('2024-01-15'),
    isDefault: true,
  },
  {
    id: '2',
    name: 'Manager Timesheet Approval',
    status: 'Active',
    stages: 3,
    assignedEmployees: 12,
    lastModified: new Date('2024-01-14'),
    isDefault: false,
  },
  {
    id: '3',
    name: 'Executive Timesheet Approval',
    status: 'Draft',
    stages: 4,
    assignedEmployees: 0,
    lastModified: new Date('2024-01-12'),
    isDefault: false,
  },
  {
    id: '4',
    name: 'Contractor Timesheet Approval',
    status: 'Active',
    stages: 2,
    assignedEmployees: 18,
    lastModified: new Date('2024-01-10'),
    isDefault: false,
  },
  {
    id: '5',
    name: 'Intern Timesheet Approval',
    status: 'Inactive',
    stages: 1,
    assignedEmployees: 8,
    lastModified: new Date('2024-01-08'),
    isDefault: false,
  },
];

// Mock approver users used for the Specific Person dropdown in demo mode
export const MOCK_APPROVER_USERS: { id: string; name: string; role: string }[] = [
  { id: '1', name: 'James Smith', role: 'Senior Consultant' },
  { id: '2', name: 'Sarah Jones', role: 'Architect' },
  { id: '3', name: 'Michael Williams', role: 'Technical Lead' },
  { id: '4', name: 'Emma Brown', role: 'Project Manager' },
  { id: '5', name: 'David Taylor', role: 'Senior Consultant' },
  { id: '6', name: 'Sophie Davies', role: 'Test Lead' },
  { id: '7', name: 'Robert Wilson', role: 'DevOps Engineer' },
  { id: '8', name: 'Emily Evans', role: 'Business Analyst' },
  { id: '9', name: 'John Thomas', role: 'Architect' },
  { id: '10', name: 'Jessica Roberts', role: 'Senior Consultant' },
  { id: '11', name: 'William Johnson', role: 'Senior Developer' },
  { id: '12', name: 'Hannah Walker', role: 'Developer' },
  { id: '13', name: 'Thomas Wright', role: 'Consultant' },
  { id: '14', name: 'Lucy Robinson', role: 'Developer' },
  { id: '15', name: 'Daniel Thompson', role: 'Consultant' },
  { id: '16', name: 'Olivia White', role: 'Developer' },
  { id: '17', name: 'Matthew Hughes', role: 'Senior Developer' },
  { id: '18', name: 'Charlotte Edwards', role: 'Developer' },
  { id: '19', name: 'Andrew Green', role: 'Consultant' },
  { id: '20', name: 'Amelia Hall', role: 'Developer' },
  { id: '21', name: 'Christopher Johnson', role: 'Consultant' },
  { id: '22', name: 'Grace Walker', role: 'Developer' },
  { id: '23', name: 'Joshua Wright', role: 'Senior Developer' },
  { id: '24', name: 'Lily Robinson', role: 'Developer' },
  { id: '25', name: 'Ryan Thompson', role: 'Consultant' },
  { id: '26', name: 'Megan White', role: 'Developer' },
  { id: '27', name: 'Benjamin Hughes', role: 'Consultant' },
  { id: '28', name: 'Chloe Edwards', role: 'Developer' },
  { id: '29', name: 'Samuel Green', role: 'Senior Developer' },
  { id: '30', name: 'Isabella Hall', role: 'Developer' },
];
